import { createFileRoute } from '@tanstack/react-router'
import { MyVisitsPage } from '../../../features/service/my-visits-page'
import { serviceMyVisitsSearchSchema } from '../../../features/service/search'

export const Route = createFileRoute('/_app/service/my-visits')({
  staticData: { crumb: 'serviceMyVisits' },
  validateSearch: serviceMyVisitsSearchSchema,
  component: MyVisitsPage,
})
